import { Box, useTheme } from "@mui/material";
import { ContractStatus } from "@/modules/property-tracks/dtos/tenants";

interface ContractStatusBadgeProps {
  status: ContractStatus;
}

const getStatusColor = (status: ContractStatus, theme: any) => {
  switch (status) {
    case "signed":
      return {
        backgroundColor: theme.nawy.colors.semantic.indicator.greenLight,
        color: theme.nawy.colors.semantic.indicator.greenDark,
      };
    case "pending_signature":
      return {
        backgroundColor: theme.nawy.colors.semantic.indicator.orangeLight,
        color: theme.nawy.colors.semantic.indicator.orangeDark,
      };
    case "draft":
      return {
        backgroundColor: theme.nawy.colors.semantic.indicator.greyLight,
        color: theme.nawy.colors.semantic.indicator.greyDark,
      };
    case "expired":
    case "terminated":
    case "cancelled":
      return {
        backgroundColor: theme.nawy.colors.semantic.indicator.redLight,
        color: theme.nawy.colors.semantic.indicator.redDark,
      };
    case "about_to_expire":
      return {
        backgroundColor: theme.nawy.colors.semantic.indicator.yellowLight,
        color: theme.nawy.colors.semantic.indicator.yellowDark,
      };
    default:
      return {
        backgroundColor: theme.nawy.colors.semantic.indicator.greyLight,
        color: theme.nawy.colors.semantic.indicator.greyDark,
      };
  }
};

const formatStatusLabel = (status: ContractStatus): string => {
  return status
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export default function ContractStatusBadge({
  status,
}: ContractStatusBadgeProps) {
  const theme = useTheme();
  const colors = getStatusColor(status, theme);

  return (
    <Box
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: theme.nawy.radius.md,
        padding: "2px 8px",
        fontSize: "12px",
        fontWeight: 500,
        backgroundColor: colors.backgroundColor,
        color: colors.color,
        textTransform: "capitalize",
      }}
    >
      {formatStatusLabel(status)}
    </Box>
  );
}